import React, { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';

import Modal from 'components/Modal';
import Drawer from 'components/Drawer';

import { setOption } from './store/actions';

import useWindowDimensions from 'helpers/hooks/useWindowDimensions';

export default function ModalDrawerSwitcher({ id, title, open, onClose, maxWidth, modalActions, anchor, children }) {
  const dispatch = useDispatch();

  const { option } = useSelector(state => state.modalDrawerSwitcher);

  const { width } = useWindowDimensions();
  const isMobile = width < 960;

  useEffect(() => {
    if(!isMobile) {
      dispatch(setOption('modal'));
    }
  }, [isMobile]);

  if(option == 'drawer' || isMobile) {
    return(
      <Drawer
        anchor={anchor}
        id={id}
        title={title}
        hasSwitcher={true}
        open={open}
        onClose={onClose}
      >
        {children}
      </Drawer>
    );
  }

  if(option == 'modal') {
    return(
      <Modal
        id={id}
        title={title}
        maxWidth={maxWidth}
        modalActions={modalActions}
        hasSwitcher={true}
        open={open}
        onClose={onClose}
      >
        {children}
      </Modal>
    );
  }
}